import { useState, useEffect } from "react";

/**
 * Returns true only after `flag` has been true for at least `delayMs` milliseconds.
 * Used to avoid showing loading/skeleton UI for very fast requests (e.g. 50–200ms).
 *
 * @param {boolean} flag - The source flag (e.g. isInitialLoading)
 * @param {number} delayMs - Delay in ms before returning true (default 200)
 * @returns {boolean} - true when flag has been true for at least delayMs
 */
export function useDelayedTrue(flag, delayMs = 200) {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return undefined;
    }
    const id = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(id);
  }, [flag, delayMs]);

  return delayed;
}
